import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'switch',
    colour: CATEGORIES.switch.color,
    textColour: '#FFFFFF',
    tooltip: 'スイッチの状態を読み取ります',
    movable: true,
    deletable: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/switch.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('スイッチ', { fontSize: 15, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'dropdown',
                    name: 'POSITION',
                    rectColour: CATEGORIES.switch.color,
                    options: [
                        { value: 'UPPER_LEFT', label: '左上' },
                        { value: 'LOWER_LEFT', label: '左下' },
                        { value: 'UPPER_RIGHT', label: '右上' },
                        { value: 'LOWER_RIGHT', label: '右下' },
                    ],
                },
                { type: 'label', text: 'を検知する ' },
            ],
        },
    ],
});
